import React from "react";

import { Typography } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";

import { Trip } from "types";

function DriverColumn(props: GridRenderCellParams<Trip>) {
  const { row } = props;

  const driver = row.routes?.[0]?.driver;

  if (!driver || (!driver.firstName && !driver.lastName)) {
    return null;
  }

  const fullName = [driver.firstName, driver.lastName]
    .filter(Boolean)
    .join(" ");

  return (
    <Typography variant="body2" noWrap>
      {fullName}
    </Typography>
  );
}

export default DriverColumn;
